// The only place that knows the classroom-delivery collection and field names.
// Curriculum records are never touched here: a delivery is a separate record
// that points at the approved lesson it delivered.

export const DELIVERY_COLLECTION = "Lesson_Deliveries";

// Enough to recognise an existing delivery and to refuse to walk a finished
// one backwards. Nothing here is ever shown to a teacher.
export const DELIVERY_FIELDS = ["id", "sync_key", "status"];

export const bySyncKey = (syncKey) => ({ sync_key: { _eq: syncKey } });

// `current_block_sort` is the `sort` of the lesson block the teacher is on.
// Records saved before block order was kept locally fall back to the step
// number, which is the same value whenever a lesson's blocks start at 0.
const blockSortOf = (record) => {
  if (Number.isInteger(record.blockSort)) return record.blockSort;
  return Number.isInteger(record.step) ? record.step : 0;
};

// The part of a delivery that changes as the lesson is taught.
export const deliveryState = (record) => ({
  status: record.status,
  completed_at: record.completedAt || null,
  current_block_sort: blockSortOf(record),
});

// Identity is written once, when the delivery is created, and never rewritten.
export const newDelivery = ({ record, lessonId, teacherId, classroomId }) => ({
  sync_key: record.syncKey,
  lesson_session: lessonId,
  classroom: classroomId,
  teacher: teacherId,
  started_at: record.startedAt || null,
  ...deliveryState(record),
});
